import processPipe from './processPipe';

function getVesselVscf12(state) {
  const pipe = processPipe(state.selectedVehicleValue);
  const r12 = Number(pipe.r12);
  const r17 = Number(pipe.r17);
  const rset = Number(pipe[`r${state.monthsFromNow}`]);

  const vscf1 = ((Math.round(r12 * 0.50 * 100)) / 12); // verified formula
  let vscf = rset * 0.50; // adjusted 2/11/10 from (vscf1 * cResponse) / 100; // verified formula by email with Cyndi Collins at DMV 6/13/08 for monthly portion of variable vscf
  const vscf12 = ((vscf1 * 12) / 100); // added 6/26 to set 12 month value of variable vessel county fee vscf
  if (vscf < 1.75) {
    vscf = 1.75;
  }

  if (r17 === 5.50) {
    // if vessel is 1-11 ft
    // obsolete for Hillsborough County
    //vscf12 = 0;
  }
  return vscf12;
}

export default getVesselVscf12;
